import { useQueryClient } from '@tanstack/react-query';
import { useEffect } from 'react';
import { matchPath, Outlet, useLocation } from 'react-router';
import { useClient } from '../../api';

export function WealthPlanningLayout() {
    const queryClient = useQueryClient();
    const { data: client } = useClient();
    const location = useLocation();

    useEffect(() => {
        if (client && !matchPath(`/wealth-planning/${client.partnerUuid}/*`, location.pathname)) {
            console.warn('We have a client, but are not on a client route, reset client', location.pathname);
            queryClient.clear();
        }
    }, [client, location, queryClient]);

    return <Outlet />;
}
